import React from "react";
import { ArrowRight } from "lucide-react";
import { openAgent } from "../../utils/openAgent";

export const SuccessStoryCtaSection = () => {

  return (
    <section 
      className="relative w-full py-16 sm:py-20 lg:py-24"
      style={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-[70px]">
        {/* Full 3D Dark Success Story Banner with Distinct Silver/Gray Outline */}
        <div className="relative w-full overflow-hidden rounded-[28px] sm:rounded-[36px] border-[2px] border-[#CBD5E1] shadow-[0_20px_50px_rgba(15,23,42,0.12)] bg-[#010915] min-h-[340px] sm:min-h-[380px] lg:min-h-[400px] flex items-center justify-center">
          {/* Full Background Image */}
          <img
            src="/images/tomorrow-banner-bg.png"
            alt="AI Success Story"
            className="absolute inset-0 h-full w-full object-cover object-center pointer-events-none"
          />

          {/* Center Banner Content matching exact screenshot */}
          <div className="relative z-10 flex w-full flex-col items-center justify-center gap-3.5 sm:gap-4 px-6 py-12 text-center sm:px-12 sm:py-16">
            {/* Eyebrow Tag */}
            <p className="text-[11px] sm:text-[12px] md:text-[12.5px] font-semibold uppercase tracking-[2.5px] text-[#94A3B8]">
              YOUR BUSINESS. YOUR OPPORTUNITY.
            </p>

            {/* Headline with exact styling and cyan highlight */}
            <h2 className="text-[28px] sm:text-[36px] md:text-[42px] lg:text-[46px] font-bold leading-[1.18] tracking-tight text-white">
              <span className="block">Your business could be our</span>
              <span className="block">
                next <span className="text-[#00D2EE]">success story.</span>
              </span>
            </h2>

            {/* Description Paragraph */}
            <p className="max-w-[560px] text-[13.5px] sm:text-[14.5px] md:text-[15px] leading-relaxed text-[#CBD5E1]">
              Tell us where you want to go. We'll help you discover where AI can
              create meaningful impact across your business.
            </p>

            {/* Vibrant Gradient Pill Button */}
            <div className="pt-2 sm:pt-3">
              <button
                onClick={openAgent}
                className="group flex items-center gap-2.5 rounded-full bg-gradient-to-r from-[#00D2EE] to-[#2F6DF6] px-8 py-3.5 sm:px-9 sm:py-4 text-[14px] sm:text-[15px] font-medium text-white shadow-[0_8px_30px_rgba(47,109,246,0.45),0_2px_12px_rgba(0,210,238,0.35)] transition-all duration-300 hover:scale-105 hover:shadow-[0_12px_40px_rgba(47,109,246,0.6),0_4px_16px_rgba(0,210,238,0.5)] active:scale-95 cursor-pointer"
              >
                <span>Discover Your AI Opportunities</span>
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.5} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStoryCtaSection;
